/** @format */

import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { WINDOW } from '@shared/data-access/services';

@Component({
  selector: 'origin-root',
  templateUrl: './app.component.html',
  // This app still bootstraps through AppModule; keep non-standalone for now.
  changeDetection: ChangeDetectionStrategy.Eager,
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class AppComponent implements OnInit {
  protected readonly window = inject(WINDOW);

  ngOnInit(): void {
    // Reset the analytics
    this.window.siteData = {};
    this.window.siteData.ErrorID = ['Site Down'];
    this.window.siteData.ErrorMessage = ["WE'RE SORRY"];
    this.window.siteData.EventData = [];
    this.window.siteData.PageName = 'Site Down';
  }
}
